import { render, staticRenderFns } from "./TypeFormModal.vue?vue&type=template&id=7f7a9e67"
import script from "./TypeFormModal.vue?vue&type=script&lang=js"
export * from "./TypeFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports